<app-modal [modalTitle]="'SHARING' | translate" [modalId]="modalId" (closeModal)="closeModalButtonTrigger()">
  <div id="modalContainer" modalBody>
    <div class="auto-complete">
      <div class="d-flex w-100" #inputElement>
        <input
          #inputRef
          class="form-control input-style input input-lg"
          [placeholder]="'ADD_USER_OR_GROUP' | translate"
          [ngClass]="{ error: showError }"
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onInputChanges()"
          (keyup.enter)="onEnterInputArea()"
          id="multi-share-email-input"
        />
        <ul class="autocomplete-list" *ngIf="showAutocomplete">
          <div *ngIf="autocompleteOptions.length === 0"></div>
          <div *ngIf="autocompleteOptions.length !== 0">
            <li *ngFor="let option of autocompleteOptions; let i = index" (click)="onOptionSelected(option)">
              <div class="person" [id]="'person' + i">
                <div class="person-picture">
                  <img
                    class="small-size"
                    id="profile-image-placeholder"
                    *ngIf="!option.user && !option.imageId; else profileImage"
                    src="/assets/images/suite/groups/thumb.svg"
                    alt=""
                  />
                  <ng-template #profileImage>
                    <app-profile-image [firstName]="option.firstName" [lastName]="option.lastName" [image]="option.imageId"></app-profile-image>
                  </ng-template>
                </div>
                <div class="person-info">
                  <div class="name" *ngIf="hasRtukUrl; else noRtukUrl">
                    {{ !option.groupName ? commonService.removeLastWord(option?.firstName!) + ' ' + option?.lastName : option?.groupName }}
                  </div>
                  <ng-template #noRtukUrl>
                    <div class="name"> {{ !option.groupName ? option?.firstName + ' ' + option?.lastName : option?.groupName }} </div>
                  </ng-template>
                  <div class="email-group">{{ option?.groupName ? option?.userCount : option?.email }}</div>
                </div>
              </div>
            </li></div
          >
        </ul>
        <button type="button" class="btn btn-primary btn-lg ti ti-users input-button-style"></button>
      </div>
    </div>
    <div class="error-message" *ngIf="showError">{{ 'SPECIFY_GROUP_OR_USER_TO_SHARE' | translate }}</div>
    <div class="info">
      <img class="mr-3" src="/assets/images/suite/storage/info-circle.svg" alt="" />
      <div class="info-text">{{ 'SHARING_WITH_SAFIR_DEPO' | translate }} </div>
    </div>
    <div class="share-table scroll">
      <table class="table">
        <caption></caption>
        <thead class="header-style">
          <tr class="bottom-style">
            <th class="header-cell cell-1">{{ 'SHARING' | translate }}</th>
            <th class="header-cell cell-2">{{ 'AUTHORITY' | translate }}</th>
            <th class="header-cell cell-3">{{ 'REMOVE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of items_; let i = index">
            <tr class="bottom-style tr-size">
              <td class="td-corner-left">
                <div class="person" [id]="'person-list' + i">
                  <div class="person-picture">
                    <img
                      id="profile-image-placeholder"
                      class="small-size"
                      *ngIf="!item.user && !item.imageId; else profileImage"
                      src="/assets/images/suite/groups/thumb.svg"
                      alt=""
                    />
                    <ng-template #profileImage>
                      <app-profile-image [firstName]="item.firstName" [lastName]="item.lastName" [image]="item.imageId"></app-profile-image>
                    </ng-template>
                  </div>
                  <div class="person-info">
                    <div class="name" *ngIf="item.user && item.firstName !== undefined">{{ item.firstName + ' ' + item.lastName }}</div>
                    <div class="name" *ngIf="!item.user">{{ item.groupName }}</div>
                    <div class="email-group">{{ item.user ? item.shareTarget : item.userCount }}</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="permission">
                  <div class="form-check">
                    <input
                      class="form-check-input mr-2 check-size"
                      (click)="changePermission(item)"
                      [(ngModel)]="item.permission"
                      name="{{ item.permission + i }}"
                      type="radio"
                      value="VIEW"
                      id="{{ 'VIEW' + i }}"
                    />
                    <label class="form-check-label label-style" for="{{ item.name + i }}"> {{ 'VIEW' | translate }}</label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input mr-2 check-size"
                      (click)="changePermission(item)"
                      [(ngModel)]="item.permission"
                      type="radio"
                      name="{{ item.permission + i }}"
                      value="EDIT"
                      id="{{ 'EDIT' + i }}"
                    />
                    <label class="form-check-label label-style" for="{{ item.name + i }}"> {{ 'EDIT' | translate }} </label>
                  </div>
                </div>
              </td>
              <td class="td-corner-right">
                <div (click)="removeItem_(item)" class="remove mt-2 ml-5"><img src="/assets/images/suite/storage/close-danger.svg" alt="" id="remove-user-btn" /></div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="note">
      <header class="note-header">{{ 'SHARE_NOTE' | translate }}</header>
      <input type="text" name="note" [(ngModel)]="shareNote" class="note-style form-control input input-lg" id="share-note" />
    </div>
  </div>
  <div modalFooter>
    <button class="btn btn-primary btn-md btn-style" [hidden]="true" #btnRef data-bs-dismiss="modal" id="share-btn">{{ 'SHARE' | translate }}</button>
    <button class="btn btn-primary btn-md btn-style" (click)="encryptedItem ? encryptedSubmit($event) : onSubmit_($event)" id="share-btn">{{ 'SHARE' | translate }}</button>
  </div>
</app-modal>
